// test2924
(2924 && 0);
